"use client";

import { usePathname } from "next/navigation";
import { useEffect, useCallback } from "react";

const ScrollToTop = () => {
  const pathname = usePathname();

  const scrollToHash = useCallback(() => {
    const hash = window.location.hash;
    
    if (hash) {
      const targetId = hash.replace("#", "");
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        // Small delay to ensure the page is fully rendered
        setTimeout(() => {
          targetElement.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
      return true;
    }
    return false;
  }, []);

  // Handle initial load and pathname changes
  useEffect(() => {
    if (!scrollToHash()) {
      window.scrollTo(0, 0);
    }
  }, [pathname, scrollToHash]);

  // Listen for hash changes (same-page navigation)
  useEffect(() => {
    const handleHashChange = () => {
      scrollToHash();
    };

    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, [scrollToHash]);

  return null;
};

export default ScrollToTop;
